// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ayaRd","notes":"Notes_notes__1Ftt0","note":"Notes_note__23FWI","markdown":"Notes_markdown__ybkow"};